<template>
  <v-container>
    <v-row justify="center" v-if="promocionSeleccionada != null && !loading">
      <v-col cols="12">
        <YearCalendar
          v-model="year"
          :activeDates.sync="activeDates"
          :lang="'es'"
          prefixClass="your_customized_wrapper_class"
          :activeClass="activeClass"
        ></YearCalendar>
      </v-col>
    </v-row>
    <v-form v-model="valid" ref="form">
      <v-row class="mt-8 mb-4" v-if="promocionSeleccionada">
        <v-col cols="12">
          <h2 class="text-h4 primary--text pb-2">LIMPIADOR@S</h2>
          <v-divider color="primary"></v-divider>
        </v-col>
      </v-row>
      <v-row v-if="promocionSeleccionada != null && !loading">
        <v-col>
          <v-label>
            Nº de limpiador@s
          </v-label>
          <v-btn color="primary" @click="addCleaner()" icon class="font-weight-bold ml-4">
            <v-icon>mdi-plus-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-for="cleaner in cleaners" :key="cleaner.id" align="center">
        <v-col cols="auto">
          <v-text-field
            label="Email"
            :rules="[rules.required, rules.email, rules.max(50)]"
            name="login"
            type="text"
            v-model="cleaner.email"
          />
        </v-col>
        <v-col cols="auto">
          <v-text-field
            label="Nombre"
            :rules="[rules.required, rules.max(50)]"
            name="nombre"
            type="text"
            v-model="cleaner.name"
          />
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            style="margin-top:0"
            v-model="cleaner.admin"
            label="Admin"
            color="primary"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col>
          <v-btn color="primary" @click="deleteCleaner(cleaner.id)" icon class="font-weight-bold ml-4">
            <v-icon>mdi-minus-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-8 mb-4" v-if="promocionSeleccionada">
        <v-col cols="12">
          <h2 class="text-h4 primary--text pb-2">HORARIOS</h2>
          <v-divider color="primary"></v-divider>
        </v-col>
      </v-row>
      <div v-if="promocionSeleccionada">
        <v-row v-for="dia in horarios" :key="dia.day">
          <v-col cols="12">
            <div class="text-subtitle-1 text-primary mb-2">
              {{ dia.day }}
            </div>
            <v-divider color="primary" style="max-width: 100px;"></v-divider>
          </v-col>
          <v-col>
            <OTimeRangeHidePicker
              :timeInicio.sync="dia.init_time"
              @updateTimeInicio="dia.init_time = $event"
              :timeFin.sync="dia.end_time"
              :disabled="!dia.check"
              :onlyHours="true"
              :rulesIni="dia.check ? [rules.required] : []"
              :rulesFin="dia.check ? [rules.required] : []"
            ></OTimeRangeHidePicker>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="dia.check"
              label="¿Activo?"
              color="primary"
              hide-details
              @change="checkMarcado(dia)"
            ></v-checkbox>
          </v-col>
        </v-row>
      </div>
      <v-row justify="center">
        <v-btn
          class="primary font-weight-bold"
          @click="guardarCalendar()"
          :disabled="promocionSeleccionada == null || !cambiado || loading"
        >
          Guardar
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import YearCalendar from 'vue-material-year-calendar'
import OTimeRangeHidePicker from '@/components/generic/Datetimes/OTimeRangeHidePicker.vue'
import rulesMixin from '@/mixins/rules'
export default {
  name: 'LimpiezaCalendar',
  mixins: [rulesMixin],
  components: { YearCalendar, OTimeRangeHidePicker },
  props: ['promocionSeleccionada', 'inicializado'],
  data() {
    return {
      loading: false,
      horarios: [
        {
          day: 'Lunes',
          init_time: null,
          end_time: null,
          check: false
        },
        {
          day: 'Martes',
          init_time: null,
          end_time: null,
          check: false
        },
        {
          day: 'Miércoles',
          init_time: null,
          end_time: null,
          check: false
        },
        {
          day: 'Jueves',
          init_time: null,
          end_time: null,
          check: false
        },
        {
          day: 'Viernes',
          init_time: null,
          end_time: null,
          check: false
        }
      ],
      horariosIni: null,
      modal2: false,
      cleaners: [],
      cleanersIni: [],
      year: 2025,
      numeroLimpiadores: null,
      numeroLimpiadoresIni: null,
      activedDatesIni: [],
      activeDates: [
        // { date: '2019-02-13' },
        // { date: '2019-02-14', className: 'red' },
        // { date: '2019-02-15', className: 'blue' },
        // { date: '2019-02-16', className: 'your_customized_classname' }
      ],
      activeClass: '',
      valid: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'login/user'
    }),
    cambiado() {
      return (
        JSON.stringify(this.cleaners) != this.cleanersIni ||
        JSON.stringify(this.horarios) != this.horariosIni ||
        JSON.stringify(this.activeDates) != JSON.stringify(this.activedDatesIni)
      )
    }
  },
  methods: {
    ...mapActions({
      loadPromotions: 'promotions/getPromotions',
      loadCalendar: 'cleaning/getCalendar',
      updateCalendar: 'cleaning/updateCalendar',
      addAlert: 'alerts/add'
    }),
    checkMarcado(dia) {
      if (!dia.check) {
        dia.init_time = null
        dia.end_time = null
      }
    },
    addCleaner() {
      this.cleaners.push({ id: uuidv4(), email: null, name: null, admin: false })
    },
    deleteCleaner(id) {
      this.cleaners = this.cleaners.filter(x => x.id != id)
    },
    async guardarCalendar() {
      if (!this.$refs.form.validate()) {
        this.addAlert({ text: 'Por favor, compruebe los campos en rojo', color: 'error' })
        return
      }
      this.loading = true
      try {
        await this.updateCalendar({
          calendar: {
            dates: this.activeDates.map(x => x.date),
            cleaners: this.numeroLimpiadores,
            horarios: this.horarios
          },
          promotion_code: this.promocionSeleccionada.promotion_code,
          cleaners: this.cleaners
        })
        this.addAlert({
          text: 'La configuración se ha guardado con éxito',
          color: 'success'
        })
      } catch (error) {
        // this.addAlert({ text: error, color: 'error' })
      } finally {
        this.loading = false
      }
    },
    allowedHours: v => v > 9 && v < 18,
    setHorarioDia(horario, horariosBack) {
      let elemento = horariosBack.length > 0 ? horariosBack.find(x => x.day == horario.day) : null
      console.log(elemento)
      if (elemento) {
        horario.init_time = elemento.init_time
        horario.end_time = elemento.end_time
        horario.check = true
      } else {
        horario.init_time = null
        horario.end_time = null
        horario.check = false
      }
    }
  },
  watch: {
    promocionSeleccionada: {
      deep: true,
      async handler() {
        if (this.inicializado) {
          this.loading = true
          let response = await this.loadCalendar({ promotion_code: this.promocionSeleccionada.promotion_code })
          this.numeroLimpiadores = response.limpiadores.length == 0 ? null : response.limpiadores.length
          this.numeroLimpiadoresIni = this.numeroLimpiadores
          this.activeDates = response.citas
          this.activedDatesIni = this.activeDates.slice(0)
          this.timeInicio = response.timeInicio
          this.timeFin = response.timeFin
          this.timeInicioIni = this.timeInicio
          this.timeFinIni = this.timeFin
          this.cleaners = response.limpiadores.slice(0)
          this.cleanersIni = JSON.stringify(this.cleaners)
          this.horarios.forEach(x => {
            this.setHorarioDia(x, response.horarios)
          })
          this.horariosIni = JSON.stringify(this.horarios)
          this.loading = false
        }
      }
    }
  }
}
</script>
<style lang="sass">
.your_customized_wrapper_class
  background-color: #0aa
  color: white
.your_customized_wrapper_class.red
    background-color: red
    color: white
.your_customized_wrapper_class.blue
    background-color: #0000aa
    color: white
.your_customized_wrapper_class.your_customized_classname
    background-color: yellow
    color: black
</style>
